import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'overview',
  size: 'full',
} as const satisfies Location
